import { FgLogo } from "@/components/FgLogo";
import { Instagram, Mail, MapPin, Phone } from "lucide-react";

const MARQUEE = [
  "FabriRent",
  "Foto reali locali",
  "Prezzo da gestionale",
  "Consegna da 5 a 90 minuti",
  "Senza carta di credito",
];

const MARQUEE_ITEMS = [...MARQUEE, ...MARQUEE];

export const Footer = () => (
  <footer id="contatti" className="bg-white" data-testid="site-footer">
    <div className="border-y border-gray-100 py-3 overflow-hidden" data-testid="footer-marquee">
      <div className="fr-marquee-track flex whitespace-nowrap w-max">
        {MARQUEE_ITEMS.map((item, i) => (
          <span key={i} className="flex items-center text-[11px] md:text-xs font-semibold text-gray-500" aria-hidden={i >= MARQUEE.length}>
            <span className="px-4">{item}</span>
            <span className="h-1.5 w-1.5 rounded-full bg-fr-red inline-block" />
          </span>
        ))}
      </div>
    </div>

    <div className="max-w-6xl mx-auto px-4 py-10 grid grid-cols-1 md:grid-cols-2 gap-8">
      <div>
        <div className="flex items-center gap-2.5">
          <FgLogo size={40} />
          <span className="leading-none">
            <span className="block font-extrabold tracking-tight text-fr-red text-base">FABRIRENT</span>
            <span className="block text-[11px] text-gray-500 font-medium mt-0.5">Noleggio Auto • Napoli</span>
          </span>
        </div>
        <p className="mt-4 text-sm text-gray-500 leading-relaxed" data-testid="footer-tagline">
          Noleggia la libertà. Dal Golfo di Napoli ovunque vuoi — consegna gratuita da 5 a 90 minuti in base alla distanza, senza carta di credito.
        </p>
      </div>

      <div>
        <p className="text-[11px] font-extrabold tracking-wider text-gray-400 uppercase">Contatti reali</p>
        <ul className="mt-3 space-y-2.5 text-sm text-gray-700">
          <li className="flex items-start gap-2.5" data-testid="footer-address">
            <MapPin size={15} className="text-fr-red shrink-0 mt-0.5" />
            <span>Sede legale: Via Selice 22, 40026 Imola (BO) • Sede operativa: Via Privata detta Sacra 33, 80145 Napoli</span>
          </li>
          <li className="flex items-center gap-2.5" data-testid="footer-phone">
            <Phone size={15} className="text-fr-red shrink-0" />
            <span>
              <a href="tel:08118351540" className="hover:text-fr-red transition-colors font-semibold">081 18351540</a> •{" "}
              <a href="tel:3509656394" className="hover:text-fr-red transition-colors font-semibold">350 9656394</a> •{" "}
              <a href="tel:3392662954" className="hover:text-fr-red transition-colors font-semibold">339 2662954</a>
            </span>
          </li>
          <li className="flex items-center gap-2.5 text-xs text-gray-500" data-testid="footer-hours">
            Lun–Sab 9:30–20:00 • Domenica chiuso
          </li>
          <li className="flex items-center gap-2.5" data-testid="footer-email">
            <Mail size={15} className="text-fr-red shrink-0" />
            <a href="mailto:Fabrirentsrls@libero.it" className="hover:text-fr-red transition-colors break-all">
              Fabrirentsrls@libero.it
            </a>
          </li>
          <li className="flex items-center gap-2.5 text-xs text-gray-500" data-testid="footer-pec">
            PEC: fabrirentmultiservice@pec.it • P.IVA 03859111209
          </li>
          <li className="flex items-center gap-2.5" data-testid="footer-instagram">
            <Instagram size={15} className="text-fr-red shrink-0" />
            <a href="https://instagram.com/fabri_rent_car" target="_blank" rel="noreferrer" className="hover:text-fr-red transition-colors">
              @fabri_rent_car
            </a>
          </li>
          <li className="flex items-center gap-2.5" data-testid="footer-review-link">
            <a href="https://g.page/r/CQfcf92RQ92nEBM/review" target="_blank" rel="noreferrer" className="text-xs font-semibold text-fr-navy hover:text-fr-red transition-colors">
              Lascia una recensione su Google
            </a>
          </li>
        </ul>
      </div>
    </div>

    <div className="border-t border-gray-100 py-4 px-4 text-center text-[10px] text-gray-400" data-testid="footer-copyright">
      © {new Date().getFullYear()} FABRI RENT MULTISERVICE SRLS — P.IVA 03859111209 • Noleggio auto a 5 minuti dall'aeroporto di Napoli – consegna in aeroporto gratuita
      <a href="/partner" className="block mt-1 text-gray-300 hover:text-gray-500 transition-colors" data-testid="footer-partner-link">
        Area Partner • Hotel e B&B
      </a>
      <a href="/admin" className="block mt-1 text-gray-300 hover:text-gray-500 transition-colors" data-testid="footer-admin-link">
        Gestionale
      </a>
      <a href="/account" className="block text-gray-300 hover:text-gray-500 transition-colors" data-testid="footer-account-link">
        Area clienti
      </a>
    </div>
  </footer>
);

export default Footer;
